export default __webpack_public_path__ + "1dee558f9da2b323ee992777daaf5ec5.png";